module.exports = __webpack_public_path__ + "static/media/device-icon.f214ca10.png";